import { defineColumn, type StrictColumnDef } from '../../../../components/tanstack-table/column';
import { unitMargin } from '../../../../data/product';
import { shortCurrencyFormatter } from '../../../../helpers/format-currency';
import type { ProductOrderItem } from '../data/product-order-item';

function computeAnnualProfit(item: ProductOrderItem): number {
  const { product } = item;

  return product.stats.last_365 * unitMargin(product);
}

export const AnnualProfit: StrictColumnDef<ProductOrderItem> = defineColumn<ProductOrderItem>({
  id: 'Annual Profit',
  minWidth: 70,
  accessorFn: (item) => shortCurrencyFormatter(computeAnnualProfit(item)),
  sortKeyFn: computeAnnualProfit,
  gloss:
    "Estimated yearly gross profit based on last year's unit sales times current margin (selling price minus last cost)",
});
